import { Model } from '@topwrite/common';

interface StateType {
    status: 'ready' | 'abort' | string
    message?: string
}

class State extends Model<StateType> {
    readonly initialState = {
        status: 'ready'
    };
}

export const state = new State();
